"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _packageorcombined = require("../shared/rules/package-or-combined");
var _default = {
    id: '6wf',
    rewards: [
        {
            id: '6-weeks-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};
